import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-[#FDFBF7]">
      <Header />
      <main className="container mx-auto px-4 md:px-6 max-w-3xl py-16 md:py-24">
        <h1 className="text-3xl md:text-4xl font-bold text-[#292524] mb-4">Privacy Policy</h1>
        <p className="text-stone-500 text-sm mb-10">Last updated: March 12, 2026</p>

        <div className="prose prose-stone max-w-none space-y-8 text-stone-700 leading-relaxed">

          <section>
            <h2 className="text-xl font-semibold text-[#292524] mb-3">1. Overview</h2>
            <p>
              SaidSimply™ ("we", "us", "our") is committed to protecting your privacy. This Privacy Policy explains what information we collect, how we use it, and what we do not do with it.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#292524] mb-3">2. Information We Collect</h2>
            <p>We collect only the information necessary to provide the Service:</p>
            <ul className="list-disc list-inside mt-2 space-y-1 text-stone-600">
              <li><strong>Account information</strong> — name and email address when you register.</li>
              <li><strong>Usage data</strong> — pages visited, features used, and interactions within the Service, collected through analytics tools.</li>
              <li><strong>Payment information</strong> — processed securely by our payment processor; we do not store full card details.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#292524] mb-3">3. How We Use Your Information</h2>
            <p>Your data is used exclusively for:</p>
            <ul className="list-disc list-inside mt-2 space-y-1 text-stone-600">
              <li><strong>Service delivery</strong> — to operate, maintain, and provide the features of SaidSimply™ to you.</li>
              <li><strong>Service improvement</strong> — to understand how paid users interact with the Service so we can improve it. Analytics data used for this purpose is associated only with paid accounts.</li>
              <li><strong>Communications</strong> — to send you service-related notifications, billing information, and responses to your inquiries.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#292524] mb-3">4. We Do Not Sell or Share Your Data</h2>
            <p>
              We do <strong>not</strong> sell, rent, lease, or otherwise provide your personal information to any third party for their marketing or commercial purposes. Period.
            </p>
            <p className="mt-3">
              We may share data with trusted service providers (e.g., payment processors, cloud infrastructure providers) solely to the extent necessary for them to perform services on our behalf. These providers are contractually prohibited from using your data for any other purpose.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#292524] mb-3">5. Analytics</h2>
            <p>
              We use Google Analytics to collect aggregated, anonymized usage data. Google Analytics may use cookies to track interactions with our website. You can opt out of Google Analytics tracking by using the <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="noopener noreferrer" className="text-[#0D9488] hover:underline">Google Analytics Opt-out Browser Add-on</a>.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#292524] mb-3">6. Data Retention</h2>
            <p>
              We retain your personal information for as long as your account is active or as needed to provide the Service. You may request deletion of your account and associated data at any time by contacting us.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#292524] mb-3">7. Security</h2>
            <p>
              We implement industry-standard security measures to protect your data. However, no method of transmission over the internet is 100% secure, and we cannot guarantee absolute security.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#292524] mb-3">8. Children's Privacy</h2>
            <p>
              The Service is directed at adults (18+). We do not knowingly collect personal information from children under 13. If we become aware that we have inadvertently collected such information, we will delete it promptly.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#292524] mb-3">9. Your Rights</h2>
            <p>
              Depending on your location, you may have the right to access, correct, or delete your personal data, or to object to certain processing. To exercise any of these rights, contact us at the address below.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#292524] mb-3">10. Changes to This Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. We will notify you of material changes via email or a prominent notice on the Service. Your continued use of the Service after changes take effect constitutes acceptance of the updated policy.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#292524] mb-3">11. Contact</h2>
            <p>
              Questions or concerns? Contact us at <a href="mailto:privacy@trysaidsimply.com" className="text-[#0D9488] hover:underline">privacy@trysaidsimply.com</a>.
            </p>
          </section>

        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
